// @ngInject
function ArticleStocksHistoryDialogService($uibModal, StockApiService) {

    return {
        showDialog: showDialog
    };

    function showDialog(articleId, locationId, articleVariantId) {

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            controller: 'ArticleStocksHistoryDialogController as vm',
            templateUrl: 'main/stock/articles/articleStocksHistory/articleStocksHistory.dialog.tpl.html',
            size: 'lg'
        };

        modalDefaults.resolve = {
            articleId: function() {
                return articleId;
            },
            locationId: function() {
                return locationId;
            },
            articleVariantId: function() {
                return articleVariantId;
            },
            article: function() {
                return StockApiService.getProduct(articleId);
            }
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function ArticleStocksHistoryDialogController($uibModalInstance, article, articleId, locationId, articleVariantId) {
    var vm = this;
    vm.article = article;

    vm.articleId = articleId;
    vm.locationId = locationId;
    vm.articleVariantId = articleVariantId;
    vm.close = close;
    vm.articleVariant = {};

    var colorvariants = _.filter(vm.article.articleVariants, { 'variantDetail1': { 'id': articleVariantId}});

    if (colorvariants.length > 0) {
        vm.articleVariant = colorvariants[0];
    }

    function close() {
        $uibModalInstance.close();
    }
}

angular.module('stock.articles.articleStocksHistory', [])
.service('ArticleStocksHistoryDialogService', ArticleStocksHistoryDialogService)
.controller('ArticleStocksHistoryDialogController', ArticleStocksHistoryDialogController);



